import React from 'react'
import PressureGauge from './PressureGauge'
// import WasteTrailerTank from './WasteTrailerTank'
import TankVisual from './TankVisual'

function toInt(value) {
    return Number(value)
}

const ParamType = React.memo(function ParamType({ param, alert = null, deviceFields }) {
    if (param?.state?.channel_type === 'pressure' || param?.data?.state?.channel_type === 'pressure') {
        return (
            <PressureGauge
                value={toInt(param?.current_value ?? param?.data?.current_value)}
                scaleMin={toInt(param?.calibration?.scale_min_eng ?? param?.data?.calibration?.scale_min_eng)}
                scaleMax={toInt(param?.calibration?.scale_max_eng ?? param?.data?.calibration?.scale_max_eng)}
                scaleUnit={param?.calibration?.scale_unit ?? param?.data?.calibration?.scale_unit}
                displayLabel={param?.state?.display_label ?? param?.data?.state?.display_label}
                displayColor={param?.state?.display_color ?? param?.data?.state?.display_color}
            />
        )
    }
    if (param?.data?.state?.channel_type === 'percent_full' || param?.state?.channel_type === 'percent_full') {
        const length = deviceFields?.length
        const width = deviceFields?.width
        const depth = deviceFields?.depth
        const shape = deviceFields?.shape?.toLowerCase() ?? 'rectangle'
        const diameter = deviceFields?.width
        let percent_level = param?.data?.percent_level ?? param?.data?.device_data?.percent_level ?? param?.device_data?.percent_level
        percent_level = toInt(percent_level);
        let inch_level = param?.data?.actual_fluid_height ?? param?.data?.device_data?.inch_level_act
        inch_level = toInt(inch_level);
        return (
            <TankVisual
                lengthVal={length ?? 96}
                widthVal={width ?? 96}
                depthVal={depth ?? 9}
                shape={shape}
                diameterVal={diameter}
                percent_level={percent_level}
                inch_level={inch_level ?? 0}
                displayColor={param?.data?.state?.display_color ?? param?.state?.display_color}
                alertColor={alert?.length > 0 ? alert[0]?.AlertType?.BadgeDetail?.border_color_hex : null}
            />
        )
        // return (
        //     <WasteTrailerTank
        //         fillPercent={toInt(param?.current_value)}
        //         capacityGallons={toInt(param?.volume_level ?? param?.device_data?.volume_level_act ?? 0)}
        //         displayLabel={param?.state?.display_label}
        //         displayColor={param?.state?.display_color}
        //     />
        // )
    }
    const length = deviceFields?.length
    const width = deviceFields?.width
    const depth = deviceFields?.depth
    const shape = deviceFields?.shape?.toLowerCase() ?? 'rectangle'
    const diameter = deviceFields?.diameter
    let percent_level = param?.percent_level ?? param?.device_data?.percent_level
    percent_level = toInt(percent_level);
    let inch_level = param?.inch_level_act ?? param?.device_data?.inch_level_act
    inch_level = toInt(inch_level);
    return (
        <TankVisual
            lengthVal={length ?? 96}
            widthVal={width ?? 96}
            depthVal={depth ?? 9}
            shape={shape}
            diameterVal={diameter}
            percent_level={percent_level}
            inch_level={inch_level ?? 0}
            displayColor={param?.state?.display_color ?? '#b6bce2'}
            alertColor={alert?.length > 0 ? alert[0]?.AlertType?.BadgeDetail?.border_color_hex : null}
        />
    )
})

export default ParamType
